import ListingSectionWithMetadata from '../transports/listing-section-with-metadata-transport'
import ListingSectionTransport, { ListingSectionObject } from '../transports/common/listing-section-transport'
import { SectionType, DataSource } from '../constants/search-result-listing'
import { TranslationFunction } from '../common/types'

export function createSectionFromTransport(
    section: ListingSectionTransport,
    page: number,
    type: SectionType,
    source: DataSource,
): ListingSectionWithMetadata | null {
    if (!section?.objects || section.objects.length === 0) {
        return null
    }

    return {
        id: `${type}-page-${page}-${source}`,
        type,
        heading: section.heading,
        subheading: section.subheading,
        objects: section.objects,
        source,
        totalCount: section.totalCount,
    }
}

export function createPartnerSection(
    objects: ListingSectionObject[],
    page: number,
    source: DataSource.HOLIDU,
    t: TranslationFunction,
    totalCount?: number,
): ListingSectionWithMetadata | null {
    if (!objects || objects.length === 0) {
        return null
    }

    const headings = {
        [DataSource.HOLIDU]: t('holiduHeading'),
    }

    const objectsWithPartnerInfo = objects.map(object => ({
        ...object,
        externalPartnerInfo: {
            name: source,
        },
    }))

    return {
        id: `partner-${source}-page-${page}`,
        type: SectionType.PARTNER,
        heading: page === 1 ? headings[source] : undefined,
        objects: objectsWithPartnerInfo,
        source,
        totalCount,
    }
}

/**
 * Filters out null sections and returns clean array
 */
export function compactSections(sections: (ListingSectionWithMetadata | null)[]): ListingSectionWithMetadata[] {
    return sections.filter((s): s is ListingSectionWithMetadata => s !== null)
}
